module.exports = __webpack_public_path__ + "fonts/iconfont.f184346c.woff2";